import {
  BoxProgrammationLightSchema,
  type BoxProgrammationLight,
} from "@/modules/boxProgrammation/gateway/boxProgramDto"
import { BoxSlotParticipationSchema, type BoxSlotParticipation } from "@modules/boxSlot/boxSlotTypes"
import { Weekdays } from "@modules/boxSlotTemplate/boxSlotTemplateTypes"
import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import z from "zod/v4"

export const ItemBoxSlotBaseDtoSchema = z
  .object({
    program: BoxProgrammationLightSchema,
    weekDay: z.enum(Weekdays),
    startTime: z.iso.time(), // Format : "10:00"
    endTime: z.iso.time(), // Format : "11:00"
    participantLimit: z.int32().nullable(),
    location: z.string().nullable(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    assignedStaffMembers: z.array(z.lazy(() => UserDtoSchema)),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
  })
  .meta({ id: "ItemBoxSlotBaseDtoSchema" })

export type ItemBoxSlotBaseDto = z.infer<typeof ItemBoxSlotBaseDtoSchema>

export const BoxSlotTemplateDtoSchema = z
  .object({
    id: z.string(),
    ...ItemBoxSlotBaseDtoSchema.shape,
  })
  .meta({ id: "BoxSlotTemplateDtoSchema" })

export type BoxSlotTemplateDto = z.infer<typeof BoxSlotTemplateDtoSchema>

export const SlotTemplateRequestDtoSchema = z
  .object({
    weekDay: z.enum(Weekdays),
    startTime: z.iso.time(),
    endTime: z.iso.time(),
    participantLimit: z.int32().nullable(),
    location: z.string().nullable(),
    participation: BoxSlotParticipationSchema.nullable(),
    allowMultiBooking: z.boolean(),
    assignedStaffMembers: z.array(z.string()),
    impactAlreadyCreatedSlot: z.boolean(),
    dropinsAccepted: z.boolean(),
    trialsAccepted: z.boolean(),
  })
  .meta({ id: "SlotTemplateRequestDtoSchema" })

export type SlotTemplateRequestDto = z.infer<typeof SlotTemplateRequestDtoSchema>

export const BoxSlotTemplateWeekDtoSchema = z
  .object({
    week: z.object({
      MONDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      TUESDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      WEDNESDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      THURSDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      FRIDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      SATURDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
      SUNDAY: z.array(BoxSlotTemplateDtoSchema).optional(),
    }),
  })
  .meta({ id: "BoxSlotTemplateWeekDtoSchema" })

export type BoxSlotTemplateWeekDto = z.infer<typeof BoxSlotTemplateWeekDtoSchema>

// OLD DTO

export type BoxSlotTemplateDraftDto = {
  id?: string
  weekDay: string
  startTime: string
  endTime: string
  participantLimit: number | null
  location?: string
  participation?: BoxSlotParticipation
  program: BoxProgrammationLight
  allowMultiBooking?: boolean
  impactAlreadyCreatedSlot?: boolean
  assignedStaffMembers: string[]
  dropinsAccepted?: boolean
  trialsAccepted?: boolean
}
